export const AREA_CHART_DOT_RADIUS = 6;
export const AREA_CHART_STROKE_WIDTH = 3;
export const AREA_CHART_REFERENCE_LINE_STROKE_WIDTH = 2;
export const AREA_CHART_REFERENCE_LINE_STROKE_DASHARRAY = "5,5";
export const AREA_CHART_REFERENCE_LINE_LABEL_POSITION = "insideBottomRight";
export const AREA_CHART_REFERENCE_LINE_FONT_WEIGHT = 600;
export const AREA_CHART_REFERENCE_LINE_FONT_SIZE = "0.75rem";
